import { BackgroundImage, Button, Card, Flex, Image, Text } from "@mantine/core";
import type { JSX } from "react";
import { ChallengeProgression } from "@/sales-tools/challenges/component/ChallengeProgression";
import { getBadgeIcon } from "@/sales-tools/challenges/utils/getBadgeIcon";
import purpleBackground from "../../../icons/PurpleBackground.png?url";
import { evaluateTeamChallenge } from "../../../utils/evaluateTeamChallenge";
import { findMyTeam } from "../../../utils/findMyTeam";
import type { ContentProps } from "../AnnouncementEndContentFactory";
import { getAnnouncementEndConfig } from "../maps";

export function AnnouncementEndTeamContent({ challenge, onDismiss, empId }: ContentProps): JSX.Element {
    const { details, badgeType } = challenge;
    const myTeam = findMyTeam(details, empId);
    const { height, width } = getBadgeSize(badgeType);
    const { result, winningTeam } = evaluateTeamChallenge({ myTeam, details });
    const { mainText, secondaryText, icon } = getAnnouncementEndConfig({
        challengeType: challenge.challengeType,
        result: result,
    });
    return (
        <Card w="450px" shadow="sm" radius="md" p="0" withBorder>
            <BackgroundImage src={purpleBackground} h={160}>
                <Flex justify="center" align="center" h={160}>
                    <Image data-testid="badge-type" src={getBadgeIcon(badgeType)} h={height} w={width} />
                </Flex>
            </BackgroundImage>

            <Flex direction="column" mt="md" gap="xs" p="lg">
                <Flex direction="column" gap={8}>
                    <Flex gap="xs">
                        <Flex w={24} align="center">
                            {icon}
                        </Flex>
                        <Text fw={"var(--mantine-font-weight-heavy)"} fz="xl">
                            {mainText(winningTeam)}
                        </Text>
                    </Flex>
                    <Text>{secondaryText}</Text>
                </Flex>
                <Flex gap={24}>
                    <ChallengeProgression challenge={challenge} displayDirection="horizontal" />
                </Flex>
                <Flex justify="flex-end">
                    <Button data-testid="acknowledge-challenge-team" onClick={onDismiss} mt="xl" maw="78px" size="sm">
                        <Text size="sm">Done</Text>
                    </Button>
                </Flex>
            </Flex>
        </Card>
    );
}

function getBadgeSize(badgeType: string): { height: number; width: number } {
    switch (badgeType) {
        case "SOLO_ANIMATED_BADGE":
        case "TEAM_ANIMATED_BADGE":
            return {
                height: 150,
                width: 150,
            };
        default:
            return {
                height: 80,
                width: 80,
            };
    }
}
